export default function (feature) {
  const { date, hours, minutes } = feature.properties;
  const dateArray = date.split('/');
  const [month, day, year] = dateArray;

  let cleanDay = day;

  if (day[0] === '0') {
    cleanDay = day.substring(1);
  }
  const months = [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ];

  const monthString = months[parseInt(month, 10) - 1];
  const hours12 = hours > 12 ? hours - 12 : hours;
  let ampm;

  if (feature.properties.am_pm === 'AM') {
    ampm = 'a.m.';
  } else if (feature.properties.am_pm === 'PM') {
    ampm = 'p.m.';
  } else {
    ampm = feature.properties.am_pm;
  }

  return `${hours12}:${minutes} ${ampm}, ${monthString} ${cleanDay}, ${year}`;
}
